var map = {
	"./all.json": 3924,
	"./full_order.greedy.json": 1459,
	"./full_order.heuristic.json": 5977,
	"./full_order.heuristic0p5.json": 5024,
	"./full_order.oblivious600.json": 3833,
	"./full_order.optimal.json": 9315,
	"./full_order.primaldual_andrews_2019.json": 5690,
	"./full_order.repeatedilp.json": 3596,
	"./full_order.repeatedilp600.json": 1826,
	"./full_order.shadowprices.json": 4909,
	"./input-data/orders.json": 1634,
	"./input-data/stores.json": 7285,
	"./order_splitting.greedy.json": 1970,
	"./order_splitting.heuristic.json": 7866,
	"./order_splitting.heuristic0p5.json": 1109,
	"./order_splitting.oblivious600.json": 1616,
	"./order_splitting.optimal.json": 1704,
	"./order_splitting.primaldual_andrews_2019.json": 1441,
	"./order_splitting.repeatedilp.json": 4663,
	"./order_splitting.repeatedilp600.json": 2435,
	"./order_splitting.shadowprices.json": 6172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1402;